/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      employees {
        nextToken
        __typename
      }
      name
      address
      objectives {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        address
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployee = /* GraphQL */ `
  query GetEmployee($id: ID!) {
    getEmployee(id: $id) {
      id
      organizationId
      organizationUnitId
      organizationUnit {
        id
        organizationId
        name
        parentId
        createdAt
        updatedAt
        __typename
      }
      userId
      user {
        id
        username
        name
        email
        createdAt
        updatedAt
        __typename
      }
      nik
      status
      domicile
      managerId
      manager {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      jobTitles {
        nextToken
        __typename
      }
      socialMedias {
        nextToken
        __typename
      }
      positionHistories {
        nextToken
        __typename
      }
      educationHistories {
        nextToken
        __typename
      }
      assignmentHistories {
        nextToken
        __typename
      }
      activities {
        nextToken
        __typename
      }
      badges {
        nextToken
        __typename
      }
      skills {
        nextToken
        __typename
      }
      trainings {
        nextToken
        __typename
      }
      rewards {
        nextToken
        __typename
      }
      objectives {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployees = /* GraphQL */ `
  query ListEmployees(
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeJobTitle = /* GraphQL */ `
  query GetEmployeeJobTitle($id: ID!) {
    getEmployeeJobTitle(id: $id) {
      id
      employeeId
      jobTitleId
      jobTitle {
        id
        organizationUnitId
        title
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeJobTitles = /* GraphQL */ `
  query ListEmployeeJobTitles(
    $filter: ModelEmployeeJobTitleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeJobTitles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        jobTitleId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getObjective = /* GraphQL */ `
  query GetObjective($id: ID!) {
    getObjective(id: $id) {
      id
      ownerId
      title
      description
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listObjectives = /* GraphQL */ `
  query ListObjectives(
    $filter: ModelObjectiveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listObjectives(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        ownerId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      username
      name
      email
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        username
        name
        email
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getJobTitle = /* GraphQL */ `
  query GetJobTitle($id: ID!) {
    getJobTitle(id: $id) {
      id
      organizationUnit {
        id
        organizationId
        name
        parentId
        createdAt
        updatedAt
        __typename
      }
      organizationUnitId
      title
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listJobTitles = /* GraphQL */ `
  query ListJobTitles(
    $filter: ModelJobTitleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listJobTitles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        organizationUnitId
        title
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getOrganizationUnit = /* GraphQL */ `
  query GetOrganizationUnit($id: ID!) {
    getOrganizationUnit(id: $id) {
      id
      organizationId
      name
      parentId
      parent {
        id
        organizationId
        name
        parentId
        createdAt
        updatedAt
        __typename
      }
      children {
        nextToken
        items {
          id
          name
        }
        __typename
      }
      objectives {
        nextToken
        items {
          title
          ownerId
          id
          description
        }
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listOrganizationUnits = /* GraphQL */ `
  query ListOrganizationUnits(
    $filter: ModelOrganizationUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationUnits(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        name
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSocialMedia = /* GraphQL */ `
  query GetSocialMedia($id: ID!) {
    getSocialMedia(id: $id) {
      id
      name
      url
      iconUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSocialMedias = /* GraphQL */ `
  query ListSocialMedias(
    $filter: ModelSocialMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSocialMedias(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        url
        iconUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeSocialMedia = /* GraphQL */ `
  query GetEmployeeSocialMedia($id: ID!) {
    getEmployeeSocialMedia(id: $id) {
      id
      employeeId
      socialMediaId
      socialMedia {
        id
        name
        url
        iconUrl
        createdAt
        updatedAt
        __typename
      }
      username
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeSocialMedias = /* GraphQL */ `
  query ListEmployeeSocialMedias(
    $filter: ModelEmployeeSocialMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeSocialMedias(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        socialMediaId
        username
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeePositionHistory = /* GraphQL */ `
  query GetEmployeePositionHistory($id: ID!) {
    getEmployeePositionHistory(id: $id) {
      id
      employeeId
      dateFrom
      dateUntil
      title
      officeName
      location
      description
      internalPosition
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeePositionHistories = /* GraphQL */ `
  query ListEmployeePositionHistories(
    $filter: ModelEmployeePositionHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeePositionHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        dateFrom
        dateUntil
        title
        officeName
        location
        description
        internalPosition
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeEducationHistory = /* GraphQL */ `
  query GetEmployeeEducationHistory($id: ID!) {
    getEmployeeEducationHistory(id: $id) {
      id
      employeeId
      schoolName
      entryYear
      graduationYear
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeEducationHistories = /* GraphQL */ `
  query ListEmployeeEducationHistories(
    $filter: ModelEmployeeEducationHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeEducationHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        schoolName
        entryYear
        graduationYear
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeAssignmentHistory = /* GraphQL */ `
  query GetEmployeeAssignmentHistory($id: ID!) {
    getEmployeeAssignmentHistory(id: $id) {
      id
      employeeId
      dateFrom
      dateUntil
      title
      officeName
      location
      description
      bodRelated
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeAssignmentHistories = /* GraphQL */ `
  query ListEmployeeAssignmentHistories(
    $filter: ModelEmployeeAssignmentHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeAssignmentHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        dateFrom
        dateUntil
        title
        officeName
        location
        description
        bodRelated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeActivity = /* GraphQL */ `
  query GetEmployeeActivity($id: ID!) {
    getEmployeeActivity(id: $id) {
      id
      employeeId
      activityId
      activity {
        id
        name
        point
        createdAt
        updatedAt
        __typename
      }
      point
      datetime
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeActivities = /* GraphQL */ `
  query ListEmployeeActivities(
    $filter: ModelEmployeeActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeActivities(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        activityId
        point
        datetime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeBadge = /* GraphQL */ `
  query GetEmployeeBadge($id: ID!) {
    getEmployeeBadge(id: $id) {
      id
      employeeId
      badgeId
      badge {
        id
        name
        description
        iconUrl
        createdAt
        updatedAt
        __typename
      }
      grantDate
      grantedById
      grantedBy {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeBadges = /* GraphQL */ `
  query ListEmployeeBadges(
    $filter: ModelEmployeeBadgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeBadges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        employeeId
        badgeId
        grantDate
        grantedById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeSkill = /* GraphQL */ `
  query GetEmployeeSkill($id: ID!) {
    getEmployeeSkill(id: $id) {
      id
      employeeId
      skillGroup
      skill
      name
      level
      progress
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeSkills = /* GraphQL */ `
  query ListEmployeeSkills(
    $filter: ModelEmployeeSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeSkills(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        employeeId
        skillGroup
        skill
        name
        level
        progress
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeTraining = /* GraphQL */ `
  query GetEmployeeTraining($id: ID!) {
    getEmployeeTraining(id: $id) {
      id
      employeeId
      date
      name
      description
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeTrainings = /* GraphQL */ `
  query ListEmployeeTrainings(
    $filter: ModelEmployeeTrainingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeTrainings(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        date
        name
        description
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeReward = /* GraphQL */ `
  query GetEmployeeReward($id: ID!) {
    getEmployeeReward(id: $id) {
      id
      employeeId
      date
      name
      description
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeRewards = /* GraphQL */ `
  query ListEmployeeRewards(
    $filter: ModelEmployeeRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeRewards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        employeeId
        date
        name
        description
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getActivity = /* GraphQL */ `
  query GetActivity($id: ID!) {
    getActivity(id: $id) {
      id
      name
      point
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listActivities = /* GraphQL */ `
  query ListActivities(
    $filter: ModelActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActivities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        point
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBadge = /* GraphQL */ `
  query GetBadge($id: ID!) {
    getBadge(id: $id) {
      id
      name
      description
      iconUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBadges = /* GraphQL */ `
  query ListBadges(
    $filter: ModelBadgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBadges(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        description
        iconUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getKnowledgeMap = /* GraphQL */ `
  query GetKnowledgeMap($id: ID!) {
    getKnowledgeMap(id: $id) {
      id
      name
      ownerId
      businessProcesses {
        nextToken
        __typename
      }
      collaborators {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listKnowledgeMaps = /* GraphQL */ `
  query ListKnowledgeMaps(
    $filter: ModelKnowledgeMapFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listKnowledgeMaps(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        ownerId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getKnowledgeMapCollaborator = /* GraphQL */ `
  query GetKnowledgeMapCollaborator($id: ID!) {
    getKnowledgeMapCollaborator(id: $id) {
      id
      employeeId
      employee {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      knowledgeMapId
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listKnowledgeMapCollaborators = /* GraphQL */ `
  query ListKnowledgeMapCollaborators(
    $filter: ModelKnowledgeMapCollaboratorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listKnowledgeMapCollaborators(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        knowledgeMapId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBusinessProcess = /* GraphQL */ `
  query GetBusinessProcess($id: ID!) {
    getBusinessProcess(id: $id) {
      id
      knowledgeMapId
      title
      description
      strategicActivities {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBusinessProcesses = /* GraphQL */ `
  query ListBusinessProcesses(
    $filter: ModelBusinessProcessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBusinessProcesses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        knowledgeMapId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getBusinessProcessComment = /* GraphQL */ `
  query GetBusinessProcessComment($id: ID!) {
    getBusinessProcessComment(id: $id) {
      id
      businessProcessId
      comment
      createdById
      createdBy {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      parentId
      replies {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listBusinessProcessComments = /* GraphQL */ `
  query ListBusinessProcessComments(
    $filter: ModelBusinessProcessCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listBusinessProcessComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessProcessId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStrategicActivity = /* GraphQL */ `
  query GetStrategicActivity($id: ID!) {
    getStrategicActivity(id: $id) {
      id
      businessProcessId
      title
      description
      importantKnowledges {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStrategicActivities = /* GraphQL */ `
  query ListStrategicActivities(
    $filter: ModelStrategicActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStrategicActivities(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessProcessId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getStrategicActivityComment = /* GraphQL */ `
  query GetStrategicActivityComment($id: ID!) {
    getStrategicActivityComment(id: $id) {
      id
      strategicActivityId
      comment
      createdById
      createdBy {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      parentId
      replies {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listStrategicActivityComments = /* GraphQL */ `
  query ListStrategicActivityComments(
    $filter: ModelStrategicActivityCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listStrategicActivityComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        strategicActivityId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getImportantKnowledge = /* GraphQL */ `
  query GetImportantKnowledge($id: ID!) {
    getImportantKnowledge(id: $id) {
      id
      strategicActivityId
      title
      description
      documents {
        nextToken
        __typename
      }
      comments {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listImportantKnowledges = /* GraphQL */ `
  query ListImportantKnowledges(
    $filter: ModelImportantKnowledgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listImportantKnowledges(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        strategicActivityId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getImportantKnowledgeComment = /* GraphQL */ `
  query GetImportantKnowledgeComment($id: ID!) {
    getImportantKnowledgeComment(id: $id) {
      id
      importantKnowledgeId
      comment
      createdById
      createdBy {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      parentId
      replies {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listImportantKnowledgeComments = /* GraphQL */ `
  query ListImportantKnowledgeComments(
    $filter: ModelImportantKnowledgeCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listImportantKnowledgeComments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        importantKnowledgeId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getImportantKnowledgeDocument = /* GraphQL */ `
  query GetImportantKnowledgeDocument($id: ID!) {
    getImportantKnowledgeDocument(id: $id) {
      id
      importantKnowledgeId
      documentType
      documentId
      document {
        id
        folderId
        filename
        filetype
        createdById
        createdAt
        updatedAt
        __typename
      }
      creatorId
      creator {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listImportantKnowledgeDocuments = /* GraphQL */ `
  query ListImportantKnowledgeDocuments(
    $filter: ModelImportantKnowledgeDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listImportantKnowledgeDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        importantKnowledgeId
        documentType
        documentId
        creatorId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCompetencyField = /* GraphQL */ `
  query GetCompetencyField($id: ID!) {
    getCompetencyField(id: $id) {
      id
      name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCompetencyFields = /* GraphQL */ `
  query ListCompetencyFields(
    $filter: ModelCompetencyFieldFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCompetencyFields(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubjectMatterExpert = /* GraphQL */ `
  query GetSubjectMatterExpert($id: ID!) {
    getSubjectMatterExpert(id: $id) {
      id
      employeeId
      employee {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      competencies {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubjectMatterExperts = /* GraphQL */ `
  query ListSubjectMatterExperts(
    $filter: ModelSubjectMatterExpertFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjectMatterExperts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSubjectMatterExpertCompetency = /* GraphQL */ `
  query GetSubjectMatterExpertCompetency($id: ID!) {
    getSubjectMatterExpertCompetency(id: $id) {
      id
      subjectMatterExpertId
      competencyFieldId
      competencyField {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSubjectMatterExpertCompetencies = /* GraphQL */ `
  query ListSubjectMatterExpertCompetencies(
    $filter: ModelSubjectMatterExpertCompetencyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSubjectMatterExpertCompetencies(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subjectMatterExpertId
        competencyFieldId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRepositoryFolder = /* GraphQL */ `
  query GetRepositoryFolder($id: ID!) {
    getRepositoryFolder(id: $id) {
      id
      files {
        nextToken
        __typename
      }
      foldername
      parentId
      parent {
        id
        foldername
        parentId
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRepositoryFolders = /* GraphQL */ `
  query ListRepositoryFolders(
    $filter: ModelRepositoryFolderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRepositoryFolders(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        foldername
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getRepositoryFile = /* GraphQL */ `
  query GetRepositoryFile($id: ID!) {
    getRepositoryFile(id: $id) {
      id
      folderId
      filename
      filetype
      createdById
      createdBy {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listRepositoryFiles = /* GraphQL */ `
  query ListRepositoryFiles(
    $filter: ModelRepositoryFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRepositoryFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        folderId
        filename
        filetype
        createdById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommunityCategory = /* GraphQL */ `
  query GetCommunityCategory($id: ID!) {
    getCommunityCategory(id: $id) {
      id
      category
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCommunityCategories = /* GraphQL */ `
  query ListCommunityCategories(
    $filter: ModelCommunityCategoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunityCategories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        category
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommunity = /* GraphQL */ `
  query GetCommunity($id: ID!) {
    getCommunity(id: $id) {
      id
      coverUrl
      profileUrl
      name
      description
      tags
      categoryId
      category {
        id
        category
        createdAt
        updatedAt
        __typename
      }
      unitId
      unit {
        id
        organizationId
        name
        parentId
        createdAt
        updatedAt
        __typename
      }
      knowledgeFocus
      objective
      kpi
      policy
      memberCanInvite
      reviewNewPost
      ownerId
      owner {
        id
        username
        name
        email
        createdAt
        updatedAt
        __typename
      }
      pendingCoreMembers {
        nextToken
        __typename
      }
      coreMembers {
        nextToken
        __typename
      }
      followers {
        nextToken
        __typename
      }
      documentations {
        nextToken
        __typename
      }
      posts {
        nextToken
        __typename
      }
      events {
        nextToken
        __typename
      }
      type
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCommunities = /* GraphQL */ `
  query ListCommunities(
    $filter: ModelCommunityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunities(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        coverUrl
        profileUrl
        name
        description
        tags
        categoryId
        unitId
        knowledgeFocus
        objective
        kpi
        policy
        memberCanInvite
        reviewNewPost
        ownerId
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPendingCoreMember = /* GraphQL */ `
  query GetPendingCoreMember($id: ID!) {
    getPendingCoreMember(id: $id) {
      id
      communityId
      employeeId
      employee {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPendingCoreMembers = /* GraphQL */ `
  query ListPendingCoreMembers(
    $filter: ModelPendingCoreMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPendingCoreMembers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communityId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCoreMember = /* GraphQL */ `
  query GetCoreMember($id: ID!) {
    getCoreMember(id: $id) {
      id
      communityId
      employeeId
      employee {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCoreMembers = /* GraphQL */ `
  query ListCoreMembers(
    $filter: ModelCoreMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCoreMembers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        communityId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommunityFollowers = /* GraphQL */ `
  query GetCommunityFollowers($id: ID!) {
    getCommunityFollowers(id: $id) {
      id
      communityId
      employeeId
      employee {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCommunityFollowers = /* GraphQL */ `
  query ListCommunityFollowers(
    $filter: ModelCommunityFollowersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunityFollowers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communityId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getCommunityDocumentation = /* GraphQL */ `
  query GetCommunityDocumentation($id: ID!) {
    getCommunityDocumentation(id: $id) {
      id
      communityId
      documentId
      document {
        id
        folderId
        filename
        filetype
        createdById
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listCommunityDocumentations = /* GraphQL */ `
  query ListCommunityDocumentations(
    $filter: ModelCommunityDocumentationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCommunityDocumentations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communityId
        documentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getPost = /* GraphQL */ `
  query GetPost($id: ID!) {
    getPost(id: $id) {
      id
      communityId
      creatorId
      creator {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      content
      documentId
      eventId
      event {
        id
        eventId
        communityId
        owner
        profileUrl
        type
        title
        description
        about
        datetimeFrom
        datetimeTo
        externalLink
        location
        createdAt
        updatedAt
        __typename
      }
      articleId
      article {
        id
        profileUrl
        status
        title
        content
        createdAt
        updatedAt
        __typename
      }
      surveyId
      survey {
        id
        name
        datetimeStart
        datetimeEnd
        createdAt
        updatedAt
        __typename
      }
      approvedBy {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listPosts = /* GraphQL */ `
  query ListPosts(
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPosts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        communityId
        creatorId
        content
        documentId
        eventId
        articleId
        surveyId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEvent = /* GraphQL */ `
  query GetEvent($id: ID!) {
    getEvent(id: $id) {
      id
      eventId
      communityId
      community {
        id
        coverUrl
        profileUrl
        name
        description
        tags
        categoryId
        unitId
        knowledgeFocus
        objective
        kpi
        policy
        memberCanInvite
        reviewNewPost
        ownerId
        type
        createdAt
        updatedAt
        __typename
      }
      owner
      profileUrl
      type
      title
      description
      about
      datetimeFrom
      datetimeTo
      externalLink
      location
      noteTakers {
        nextToken
        __typename
      }
      employeeSpeakers {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      externalSpeakers {
        id
        name
        jobTitle
        company
        photo_url
        createdAt
        updatedAt
        __typename
      }
      committees {
        nextToken
        __typename
      }
      documentations {
        nextToken
        __typename
      }
      attendeeIds {
        nextToken
        __typename
      }
      messages {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEvents = /* GraphQL */ `
  query ListEvents(
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventId
        communityId
        owner
        profileUrl
        type
        title
        description
        about
        datetimeFrom
        datetimeTo
        externalLink
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getNoteTakers = /* GraphQL */ `
  query GetNoteTakers($id: ID!) {
    getNoteTakers(id: $id) {
      id
      eventId
      employeeId
      employee {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listNoteTakers = /* GraphQL */ `
  query ListNoteTakers(
    $filter: ModelNoteTakersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNoteTakers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getComittee = /* GraphQL */ `
  query GetComittee($id: ID!) {
    getComittee(id: $id) {
      id
      eventId
      employeeId
      employee {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listComittees = /* GraphQL */ `
  query ListComittees(
    $filter: ModelComitteeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComittees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAttendee = /* GraphQL */ `
  query GetAttendee($id: ID!) {
    getAttendee(id: $id) {
      id
      employeeId
      employee {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listAttendees = /* GraphQL */ `
  query ListAttendees(
    $filter: ModelAttendeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAttendees(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEmployeeSpeaker = /* GraphQL */ `
  query GetEmployeeSpeaker($id: ID!) {
    getEmployeeSpeaker(id: $id) {
      id
      employeeId
      employe {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEmployeeSpeakers = /* GraphQL */ `
  query ListEmployeeSpeakers(
    $filter: ModelEmployeeSpeakerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmployeeSpeakers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEventSpeaker = /* GraphQL */ `
  query GetEventSpeaker($id: ID!) {
    getEventSpeaker(id: $id) {
      id
      name
      jobTitle
      company
      photo_url
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEventSpeakers = /* GraphQL */ `
  query ListEventSpeakers(
    $filter: ModelEventSpeakerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventSpeakers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        jobTitle
        company
        photo_url
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getEventMessage = /* GraphQL */ `
  query GetEventMessage($id: ID!) {
    getEventMessage(id: $id) {
      id
      eventId
      from {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      toId {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      message
      parentId
      parent {
        id
        eventId
        message
        parentId
        attachmentUrl
        createdAt
        updatedAt
        __typename
      }
      replies {
        nextToken
        __typename
      }
      attachmentUrl
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listEventMessages = /* GraphQL */ `
  query ListEventMessages(
    $filter: ModelEventMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEventMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        eventId
        message
        parentId
        attachmentUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getArticle = /* GraphQL */ `
  query GetArticle($id: ID!) {
    getArticle(id: $id) {
      id
      profileUrl
      status
      owner {
        id
        username
        name
        email
        createdAt
        updatedAt
        __typename
      }
      title
      content
      createdAt
      createdBy {
        id
        username
        name
        email
        createdAt
        updatedAt
        __typename
      }
      updatedAt
      updatedBy {
        id
        username
        name
        email
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
  }
`;
export const listArticles = /* GraphQL */ `
  query ListArticles(
    $filter: ModelArticleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listArticles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        profileUrl
        status
        title
        content
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurvey = /* GraphQL */ `
  query GetSurvey($id: ID!) {
    getSurvey(id: $id) {
      id
      name
      datetimeStart
      datetimeEnd
      options {
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveys = /* GraphQL */ `
  query ListSurveys(
    $filter: ModelSurveyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveys(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        datetimeStart
        datetimeEnd
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getSurveyOption = /* GraphQL */ `
  query GetSurveyOption($id: ID!) {
    getSurveyOption(id: $id) {
      id
      surveyOptionId
      caption
      totalVote
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listSurveyOptions = /* GraphQL */ `
  query ListSurveyOptions(
    $filter: ModelSurveyOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSurveyOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        surveyOptionId
        caption
        totalVote
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeesByOrganizationId = /* GraphQL */ `
  query EmployeesByOrganizationId(
    $organizationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeesByOrganizationId(
      organizationId: $organizationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeesByUserId = /* GraphQL */ `
  query EmployeesByUserId(
    $userId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeesByUserId(
      userId: $userId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        organizationUnitId
        userId
        nik
        status
        domicile
        managerId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeJobTitlesByEmployeeId = /* GraphQL */ `
  query EmployeeJobTitlesByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeJobTitleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeJobTitlesByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        jobTitleId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeJobTitlesByJobTitleId = /* GraphQL */ `
  query EmployeeJobTitlesByJobTitleId(
    $jobTitleId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeJobTitleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeJobTitlesByJobTitleId(
      jobTitleId: $jobTitleId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        jobTitleId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const objectivesByOwnerId = /* GraphQL */ `
  query ObjectivesByOwnerId(
    $ownerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelObjectiveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    objectivesByOwnerId(
      ownerId: $ownerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        ownerId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const organizationUnitsByOrganizationId = /* GraphQL */ `
  query OrganizationUnitsByOrganizationId(
    $organizationId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    organizationUnitsByOrganizationId(
      organizationId: $organizationId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        name
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const organizationUnitsByParentId = /* GraphQL */ `
  query OrganizationUnitsByParentId(
    $parentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelOrganizationUnitFilterInput
    $limit: Int
    $nextToken: String
  ) {
    organizationUnitsByParentId(
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        organizationId
        name
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeSocialMediasByEmployeeId = /* GraphQL */ `
  query EmployeeSocialMediasByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeSocialMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeSocialMediasByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        socialMediaId
        username
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeSocialMediasBySocialMediaId = /* GraphQL */ `
  query EmployeeSocialMediasBySocialMediaId(
    $socialMediaId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeSocialMediaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeSocialMediasBySocialMediaId(
      socialMediaId: $socialMediaId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        socialMediaId
        username
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeePositionHistoriesByEmployeeId = /* GraphQL */ `
  query EmployeePositionHistoriesByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeePositionHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeePositionHistoriesByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        dateFrom
        dateUntil
        title
        officeName
        location
        description
        internalPosition
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeEducationHistoriesByEmployeeId = /* GraphQL */ `
  query EmployeeEducationHistoriesByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeEducationHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeEducationHistoriesByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        schoolName
        entryYear
        graduationYear
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeAssignmentHistoriesByEmployeeId = /* GraphQL */ `
  query EmployeeAssignmentHistoriesByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeAssignmentHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeAssignmentHistoriesByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        dateFrom
        dateUntil
        title
        officeName
        location
        description
        bodRelated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeActivitiesByEmployeeId = /* GraphQL */ `
  query EmployeeActivitiesByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeActivitiesByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        activityId
        point
        datetime
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeBadgesByEmployeeId = /* GraphQL */ `
  query EmployeeBadgesByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeBadgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeBadgesByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        badgeId
        grantDate
        grantedById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeSkillsByEmployeeId = /* GraphQL */ `
  query EmployeeSkillsByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeSkillFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeSkillsByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        skillGroup
        skill
        name
        level
        progress
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeTrainingsByEmployeeId = /* GraphQL */ `
  query EmployeeTrainingsByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeTrainingFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeTrainingsByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        date
        name
        description
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeRewardsByEmployeeId = /* GraphQL */ `
  query EmployeeRewardsByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeRewardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeRewardsByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        date
        name
        description
        type
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const knowledgeMapsByOwnerId = /* GraphQL */ `
  query KnowledgeMapsByOwnerId(
    $ownerId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelKnowledgeMapFilterInput
    $limit: Int
    $nextToken: String
  ) {
    knowledgeMapsByOwnerId(
      ownerId: $ownerId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        ownerId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const knowledgeMapCollaboratorsByEmployeeId = /* GraphQL */ `
  query KnowledgeMapCollaboratorsByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelKnowledgeMapCollaboratorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    knowledgeMapCollaboratorsByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        knowledgeMapId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const knowledgeMapCollaboratorsByKnowledgeMapId = /* GraphQL */ `
  query KnowledgeMapCollaboratorsByKnowledgeMapId(
    $knowledgeMapId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelKnowledgeMapCollaboratorFilterInput
    $limit: Int
    $nextToken: String
  ) {
    knowledgeMapCollaboratorsByKnowledgeMapId(
      knowledgeMapId: $knowledgeMapId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        knowledgeMapId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const businessProcessesByKnowledgeMapId = /* GraphQL */ `
  query BusinessProcessesByKnowledgeMapId(
    $knowledgeMapId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessProcessFilterInput
    $limit: Int
    $nextToken: String
  ) {
    businessProcessesByKnowledgeMapId(
      knowledgeMapId: $knowledgeMapId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        knowledgeMapId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const businessProcessCommentsByBusinessProcessId = /* GraphQL */ `
  query BusinessProcessCommentsByBusinessProcessId(
    $businessProcessId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessProcessCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    businessProcessCommentsByBusinessProcessId(
      businessProcessId: $businessProcessId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessProcessId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const businessProcessCommentsByParentId = /* GraphQL */ `
  query BusinessProcessCommentsByParentId(
    $parentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelBusinessProcessCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    businessProcessCommentsByParentId(
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessProcessId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const strategicActivitiesByBusinessProcessId = /* GraphQL */ `
  query StrategicActivitiesByBusinessProcessId(
    $businessProcessId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStrategicActivityFilterInput
    $limit: Int
    $nextToken: String
  ) {
    strategicActivitiesByBusinessProcessId(
      businessProcessId: $businessProcessId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        businessProcessId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const strategicActivityCommentsByStrategicActivityId = /* GraphQL */ `
  query StrategicActivityCommentsByStrategicActivityId(
    $strategicActivityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStrategicActivityCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    strategicActivityCommentsByStrategicActivityId(
      strategicActivityId: $strategicActivityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        strategicActivityId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const strategicActivityCommentsByParentId = /* GraphQL */ `
  query StrategicActivityCommentsByParentId(
    $parentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelStrategicActivityCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    strategicActivityCommentsByParentId(
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        strategicActivityId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const importantKnowledgesByStrategicActivityId = /* GraphQL */ `
  query ImportantKnowledgesByStrategicActivityId(
    $strategicActivityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelImportantKnowledgeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    importantKnowledgesByStrategicActivityId(
      strategicActivityId: $strategicActivityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        strategicActivityId
        title
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const importantKnowledgeCommentsByImportantKnowledgeId = /* GraphQL */ `
  query ImportantKnowledgeCommentsByImportantKnowledgeId(
    $importantKnowledgeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelImportantKnowledgeCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    importantKnowledgeCommentsByImportantKnowledgeId(
      importantKnowledgeId: $importantKnowledgeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        importantKnowledgeId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const importantKnowledgeCommentsByParentId = /* GraphQL */ `
  query ImportantKnowledgeCommentsByParentId(
    $parentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelImportantKnowledgeCommentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    importantKnowledgeCommentsByParentId(
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        importantKnowledgeId
        comment
        createdById
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const importantKnowledgeDocumentsByImportantKnowledgeId = /* GraphQL */ `
  query ImportantKnowledgeDocumentsByImportantKnowledgeId(
    $importantKnowledgeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelImportantKnowledgeDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    importantKnowledgeDocumentsByImportantKnowledgeId(
      importantKnowledgeId: $importantKnowledgeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        importantKnowledgeId
        documentType
        documentId
        creatorId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subjectMatterExpertCompetenciesBySubjectMatterExpertId = /* GraphQL */ `
  query SubjectMatterExpertCompetenciesBySubjectMatterExpertId(
    $subjectMatterExpertId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSubjectMatterExpertCompetencyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    subjectMatterExpertCompetenciesBySubjectMatterExpertId(
      subjectMatterExpertId: $subjectMatterExpertId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        subjectMatterExpertId
        competencyFieldId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const repositoryFoldersByParentId = /* GraphQL */ `
  query RepositoryFoldersByParentId(
    $parentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRepositoryFolderFilterInput
    $limit: Int
    $nextToken: String
  ) {
    repositoryFoldersByParentId(
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        foldername
        parentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const repositoryFilesByFolderId = /* GraphQL */ `
  query RepositoryFilesByFolderId(
    $folderId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelRepositoryFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    repositoryFilesByFolderId(
      folderId: $folderId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        folderId
        filename
        filetype
        createdById
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const pendingCoreMembersByCommunityId = /* GraphQL */ `
  query PendingCoreMembersByCommunityId(
    $communityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPendingCoreMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    pendingCoreMembersByCommunityId(
      communityId: $communityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communityId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const coreMembersByCommunityId = /* GraphQL */ `
  query CoreMembersByCommunityId(
    $communityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCoreMemberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    coreMembersByCommunityId(
      communityId: $communityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communityId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const communityFollowersByCommunityId = /* GraphQL */ `
  query CommunityFollowersByCommunityId(
    $communityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCommunityFollowersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    communityFollowersByCommunityId(
      communityId: $communityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communityId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const communityDocumentationsByCommunityId = /* GraphQL */ `
  query CommunityDocumentationsByCommunityId(
    $communityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCommunityDocumentationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    communityDocumentationsByCommunityId(
      communityId: $communityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communityId
        documentId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const postsByCommunityId = /* GraphQL */ `
  query PostsByCommunityId(
    $communityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelPostFilterInput
    $limit: Int
    $nextToken: String
  ) {
    postsByCommunityId(
      communityId: $communityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        communityId
        creatorId
        content
        documentId
        eventId
        articleId
        surveyId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventsByCommunityId = /* GraphQL */ `
  query EventsByCommunityId(
    $communityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEventFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventsByCommunityId(
      communityId: $communityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        communityId
        owner
        profileUrl
        type
        title
        description
        about
        datetimeFrom
        datetimeTo
        externalLink
        location
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const noteTakersByEventId = /* GraphQL */ `
  query NoteTakersByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelNoteTakersFilterInput
    $limit: Int
    $nextToken: String
  ) {
    noteTakersByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const comitteesByEventId = /* GraphQL */ `
  query ComitteesByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelComitteeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    comitteesByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const attendeesByEmployeeId = /* GraphQL */ `
  query AttendeesByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelAttendeeFilterInput
    $limit: Int
    $nextToken: String
  ) {
    attendeesByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const employeeSpeakersByEmployeeId = /* GraphQL */ `
  query EmployeeSpeakersByEmployeeId(
    $employeeId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEmployeeSpeakerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    employeeSpeakersByEmployeeId(
      employeeId: $employeeId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        employeeId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventMessagesByEventId = /* GraphQL */ `
  query EventMessagesByEventId(
    $eventId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEventMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventMessagesByEventId(
      eventId: $eventId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        message
        parentId
        attachmentUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const eventMessagesByParentId = /* GraphQL */ `
  query EventMessagesByParentId(
    $parentId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelEventMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    eventMessagesByParentId(
      parentId: $parentId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        eventId
        message
        parentId
        attachmentUrl
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const surveyOptionsBySurveyOptionId = /* GraphQL */ `
  query SurveyOptionsBySurveyOptionId(
    $surveyOptionId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelSurveyOptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    surveyOptionsBySurveyOptionId(
      surveyOptionId: $surveyOptionId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        surveyOptionId
        caption
        totalVote
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
